<template>
  <div ref="widthRef">
    <div class="jumbotron">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#/home">Home</a></li>
        <li class="breadcrumb-item active">Apps</li>
      </ol>
      <div class="row">
        <div class="col-md-4">
          <div class="card card-inverse card-info text-xs-center">
            <div class="card-block">
              <blockquote class="card-blockquote">
                <p>Visualize db performance and scheduled functions results</p>
              </blockquote>
              <i aria-hidden="true" class="fas fa-chart-pie card-block-watermark"></i>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-inverse card-warning text-xs-center">
            <div class="card-block">
              <blockquote class="card-blockquote">
                <p>Set timeout values for scheduled functions and views</p>
              </blockquote>
              <i aria-hidden="true" class="fa fa-wrench card-block-watermark"></i>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-inverse card-success text-xs-center">
            <div class="card-block">
              <blockquote class="card-blockquote">
                <p>Stream Helium app logs directly to your browser</p>
              </blockquote>
              <i aria-hidden="true" class="fa fa-history card-block-watermark"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row table-search-header">
      <div class="col">
        {{ $parent.apps.length }} apps found from
        {{ $parent.$parent.baseUrl }}/helium/api/v2/app
      </div>
    </div>
    <vue-good-table
        title=""
        :columns="columns"
        :rows="apps"
        :sort-options="{
          enabled: true,
          initialSortBy: {field: 'name', type: 'asc'}
        }"
        :search-options="{ enabled: true }"
        :paginationOptions="{ enabled: true }"
        styleClass="vgt-table striped bordered table-hover"
        :lineNumbers="true"
        >
      <template slot="table-row" slot-scope="props">
         <span v-if="props.column.field == 'name'">
            {{props.row.name}}
        </span>
        <span v-if="props.column.field == 'id'">
            {{props.row.id}}
        </span>
        <span v-if="props.column.field == 'fqdn'">
            {{props.row.fqdn}}
        </span>
        <span v-if="props.column.label == 'Actions'">
            <button type="button" class="btn btn-info" v-on:click="view(props.row)">
              <i class="fas fa-chart-pie" aria-hidden="true"></i> View
            </button>
            <button type="button" class="btn btn-warning" v-on:click="config(props.row)">
              <i class="fa fa-wrench" aria-hidden="true"></i> Config
            </button>
            <button type="button" class="btn btn-success" v-on:click="logs(props.row)">
              <i class="fa fa-history" aria-hidden="true"></i> Logs
            </button>  
            <button type="button" class="btn btn-error" v-on:click="scheduledfunctions(props.row)">
              <i class="fa fa-tasks" aria-hidden="true"></i> Scheduled Functions
            </button>
        </span>     
      </template>
    </vue-good-table>
  </div>
</template>

<script>
  export default {
    name: 'Apps',
    components: {
    },
    data: function () {
      return {
        apps: [],
        width: 601
      }
    },
    methods: {
      view: function (entry) {
        this.$router.push({name: 'AppsParam', params: {appid: entry.id}})
        this.$router.push({name: 'AppView', params: {appid: entry.id}})
      },
      config: function (entry) {
        this.$router.push({name: 'AppsParam', params: {appid: entry.id}})
        this.$router.push({name: 'Config', params: {appid: entry.id}})
      },
      logs: function (entry) {
        this.$router.push({name: 'AppsParam', params: {appid: entry.id}})
        this.$router.push({name: 'Logs', params: {appid: entry.id}})
      },
      scheduledfunctions: function (entry) {
        this.$router.push({name: 'AppsParam', params: {appid: entry.id}})
        this.$router.push({name: 'ScheduledFunctions', params: {appid: entry.id}})
      },
      windowResizeCallback: function () {
        this.width = this.$refs.widthRef.clientWidth
      },
      isMobileDevice: function () {
        return (/iphone|ipod|android|ie|blackberry|fennec/).test(navigator.userAgent.toLowerCase())
      },
      showAppId: function () {
        return this.width > 750 && !this.isMobileDevice()
      }
    },
    computed: {
      columns: function () {
        if (this.showAppId()) {
          return [
            {
              label: 'Name',
              field: 'name'
            },
            {
              label: 'ID',
              field: 'id'
            },
            {
              label: 'FQDN',
              field: 'fqdn'
            },
            {
              label: 'Actions',
              field: 'btn',
              html: true
            }
          ]
        } else {
          return [
            {
              label: 'Name',
              field: 'name'
            },
            {
              label: 'FQDN',
              field: 'fqdn'
            },
            {
              label: 'Actions',
              field: 'btn',
              html: true
            }
          ]
        }
      }
    },
    mounted () {
      this.windowResizeCallback()
      window.addEventListener('resize', this.windowResizeCallback)
      this.apps = this.$parent.apps
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.windowResizeCallback)
    }
  }
</script>

<style scoped>
  .table-search-header {
    padding-bottom: 20px;
    padding-top: 5px;
    color: #757575;
  }

  .card-block-watermark {
    font-size: 2rem;
    position: absolute;
    bottom: 5px;
    right: 5px;
    opacity: 0.3;
  }
</style>



// WEBPACK FOOTER //
// Apps.vue?3d7f49b6